import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import paths from '../../routes/paths'
import { verifyQRCode } from '../../actions/orderActions'
import { useHistory } from 'react-router-dom'

let firstTime = true

const VerifyQRCode = ({ match }) => {
    const { hash } = match.params
    const { orderMethod } = useSelector(state => state.OrderReducer)
    const dispatch = useDispatch()
    const history = useHistory()

    const handleVerifyQRCode = () => {
        dispatch(
            verifyQRCode({
                params: {
                    hash,
                },
                onDone: () => {
                    history.push(paths.listFood)
                },
            })
        )
    }

    useEffect(() => {
        if (orderMethod) {
            firstTime
                ? history.push(paths.notFound)
                : history.push(paths.listFood)
        } else {
            handleVerifyQRCode()
        }
        firstTime = false
    }, [])

    return null
}

export default VerifyQRCode
